import { createRouter, createWebHistory } from 'vue-router'

import {authStore} from "@/store/authStore";
import {configStore} from "@/store/configStore";

import login from "@/views/loginView";

import navBar from "@/components/navBar/navBar";
import dashboardView from "@/views/dashboardView";
import kundenportale from "@/views/kundenportale";
import profil from "@/views/profil";
import nutzerverwaltung from "@/views/nutzerverwaltung";
import nutzerOverview from "@/views/nutzerverwaltung/overview";
import nutzerEdit from "@/views/nutzerverwaltung/edit";
import RegisterView from "@/views/RegisterView";
import portalOverview from "@/views/kundenportale/overview";
import portalEdit from "@/views/kundenportale/edit";
import portalUsermanagement from "@/views/kundenportale/usermanagement";
import portalOrders from "@/views/kundenportale/orders";

const routes = [
  {
    path: '/',
    alias: '/login',
    name: 'Login',
    components: {
      default: login
    },
    meta: { noAuth: true },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    components: {
      navBar: navBar,
      default: dashboardView
    },
    meta: { auth: true },
  },
  {
    path: '/nutzerverwaltung/:page?',
    name: 'Nutzerverwaltung',
    components: {
      navBar: navBar,
      default: nutzerverwaltung,
    },
    children: [
      {
        path: '',
        name: 'NutzerOverview',
        component: nutzerOverview
      },
      {
        path: 'edit/:id',
        name: 'NutzerEdit',
        component: nutzerEdit
      }
    ],
    meta: { auth: true },
  },
  {
    path: '/register/:token',
    name: 'Register',
    components: {
      default: RegisterView,
    },
    props: true,
    meta: { noAuth: true },
  },
  {
    path: '/kundenportale/:page?',
    name: 'Kundenportale',
    components: {
      navBar: navBar,
      default: kundenportale,
    },
    children: [
      {
        path: '',
        name: 'PortalOverview',
        component: portalOverview
      },
      {
        path: 'edit/:id',
        name: 'PortalEdit',
        component: portalEdit
      },
      {
        path: 'usermanagement/:id',
        name: 'PortalUsermanagement',
        component: portalUsermanagement
      },
      {
        path: 'orders/:id',
        name: 'PortalOrders',
        component: portalOrders
      }
    ],
    meta: { auth: true },
  },
  {
    path: '/profil',
    name: 'Profil',
    components: {
      navBar: navBar,
      default: profil
    },
    meta: { auth: true },
  },
  {
    name: '404',
    path: '/:pathMatch(.*)*',
    alias: '/404',
    redirect: () => {
      return { path: '/' }
    },
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const auth = authStore()
  const config = configStore()

  window.scrollTo(0, 0)
  window.onscroll = function () {}

  if (to.matched.some(record => record.meta.auth)) {
    auth.update()
        .then(r => {
          config.loading = true
          next()
        })
        .catch(e => {
          console.error(e)
          next({
            path: '/login',
            query: { redirect: encodeURI(to.fullPath) }
          })
        })
  } else if (to.matched.some(record => record.meta.noAuth)) {
    auth.update()
        .then(() => {
          next({
            name: 'Dashboard'
          })
        })
        .catch((e)=> {
          next()
        })
        .finally(function () {
          config.loading = true
        })
  } else {
    auth.update()
        .catch(e =>{
        })
        .finally(() => {
          config.loading = true
          next()
        })
  }
})

let history = []
router.afterEach((to, from) => {
  if(to.path === history.at(-2)?.path){
    to.meta.transition = history.at(-2).direction === 'slide-right' ? 'slide-left' : 'slide-right'
    history.pop()
  }else{
    to.meta.transition = to.path.split('/').length < from.path.split('/').length ? 'slide-right' : 'slide-left'
    history.push({path: to.path, direction: to.meta.transition})
  }
})

export default router
